import Vue from "vue";
import Vuex from "vuex";
import { searchTaskDataApi, searchUserTaskWaiAuditApi } from "@/utils/api";
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    count: 0,
  },

  // 同步修改状态的方法
  mutations: {
    setcount(state, count) {
      state.count = count;
    },
  },

  // 异步操作
  actions: {
    async setcountFn({ commit }) {
      const res = await searchTaskDataApi({
        page: 1,
        pageSize: 1,
        tdStatus: "已上传视频",
      });
      const res2 = await searchUserTaskWaiAuditApi({
        auditStatus: "",
        page: 1,
        pageSize: 1,
        auditStatus: "待审核",
        submitStatus: "已提交",
      });
      commit("setcount", res.date.total + res2.date.total);
    },
  },

  // 计算属性
  getters: {
    count: (state) => state.count,
  },
});

export default store;
